import { services } from '../services';
var action = "item";

export const itemService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    report,
    itemListReport
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function report(object) {
    return services.restApi(`${action}/eod`, 'POST', object);
}

function itemListReport(object) {
    return services.restApi(`${action}/itemList`, 'POST', object);
}